<template>
    <div class="field">
        <div class="field">
            <div class="control has-icons-left">
                <input v-model="user"
                v-bind:class="{ 'is-danger': error && error.length > 0 }"
                class="input"
                type="text"
                placeholder="Type User"
                disabled>
                <span class="icon is-left">
                    <i class="fas fa-user"></i>
                </span>
            </div>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            user: {
                get: function () {
                    return this.$store.getters.getNewCarUserName
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorUser
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/UserSelect.vue